import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const WhyWeLikeSection = ({ languageData, spaceData }) => {
  const whyWeLikeText =
    languageData === 'EN'
      ? spaceData?.space_details_general_en
      : spaceData?.space_details_general;

  const whyBookText =
    languageData === 'EN'
      ? spaceData?.space_details_en
      : spaceData?.space_details;

  return (
    <FlexContainer className="bgGradientBlue borderrad14 width100 flex-column pad20">
      <Label className="text-16" style={{ fontWeight: 700 }}>
        {languageData === 'EN' ? 'Why We Like It' : 'Por qué nos gusta'}
      </Label>

      <Label
        className="text-13 lineHeight-1-6 margt10"
        style={{ opacity: 0.9 }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: whyWeLikeText || '',
          }}
        />
      </Label>

      <div className="width100 margt40"></div>

      <Label className="text-16 margt15" style={{ fontWeight: 700 }}>
        {languageData === 'EN'
          ? 'Why Book with Us'
          : 'Por qué reservar con nosotros'}
      </Label>

      <Label
        className="text-13 lineHeight-1-6 margt10"
        style={{ opacity: 0.9 }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: whyBookText || '',
          }}
        />
      </Label>
    </FlexContainer>
  );
};

export default WhyWeLikeSection;
